//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: {
      type: String,
      default: null
    },
    text1: {
      type: String,
      default: null
    },
    img: {
      type: String,
      default: null
    },
    title2: {
      type: String,
      default: null
    },
    text2: {
      type: String,
      default: null
    },
    text3: {
      type: String,
      default: null
    },
    reverse: {
      type: Boolean,
      default: false
    }
  }
}
